module.exports = __webpack_public_path__ + "static/media/IMG_1190.c1b4049f.jpg";